<template>
  <div class="start d-flex flex-column ai-end p-relative my-container" :class="{ 'start-blur': showNewsAll }"
    :style="{ 'touch-action': 'auto' }" @click.self="hideAll">
    <img class="location animate__animated op0" v-intersect="'animate__zoomIn'" src="../assets/img/location.png" />
    <!-- <img class="video1 animate__animated op0" v-intersect="'animate__zoomIn'"
      v-lazy="'../assets/img/appearance.jpg'" /> -->
    <img class="east animate__animated op0" v-intersect="'animate__fadeInRight'" src="../assets/img/east.png" />
    <div class="d-flex flex-column ai-center" :style="{
      transform: `rotate(90deg) scale(1,1)`,
      'transform-origin': 'center',
      'margin-top': '15vmin',
      'margin-right': '5vmin'
    }">
      <video controlsList="noplaybackrate noremoteplayback nodownload" ref="video1" controls @play="onPlay('video1')"
        @pause="onPause('video1Playing')" class="video1" poster="../assets/img/pre1.jpg">
        <source src="https://pic-cdn.bigdatajy.com/jiazhuanshang/chongqing-yjcs.mp4" type="video/mp4" />
        Sorry, your browser doesn't support embedded videos.
      </video>
      <img style="height: 4vmin;margin-top: 4vmin;" class="animate__animated op0 animate__delay"
        v-intersect="'animate__flipInX'" src="../assets/img/videoTitle1.png" />
    </div>

    <div class="p-relative" :style="{
      transform: `rotate(90deg) scale(1,1)`,
      'transform-origin': 'center',
      'margin-top': '33vmin',
      'margin-right': '-8vmin',
      'z-index': 1001
    }">
      <div class="p-absolute bg-white iframe-content d-flex" style="top: 0;right: -18vmax;" v-if="showNews1">
        <iframe class="new-content" frameborder="no" :src="url" @load="loaded('iframe1')" ref="iframe1"></iframe>
        <div :class="{ 'close-bg': showIcon, op0: !showIcon }" @click="showNews1 = false">
          <van-icon name="cross" size="32" />
        </div>
      </div>
      <img class="mt-4vmin animate__animated op0 animate__delay" v-intersect="'animate__flipInX'"
        style="width: 25.1vmin;height: 5.87vmin;" src="../assets/img/focus.png" />
      <img class="mt-4vmin animate__animated op0 animate__delay" v-intersect="'animate__flipInX'" @click="
        newsClick(
          'http://newht.ijiangyin.com:5577/index.php/portal/news/index?id=558161&overflowx=auto&closeshare=1',
          'showNews1'
        )
        " style="width: 66.53vmin;height: 8.66vmin;" src="../assets/img/xingfu.png" id="chai" />
      <img class="mt-4vmin animate__animated op0 animate__delay" v-intersect="'animate__flipInX'" @click="
        newsClick(
          'http://newht.ijiangyin.com:5577/index.php/portal/news/index?id=558145&overflowx=auto&closeshare=1',
          'showNews1'
        )
        " style="width: 61.34vmin;height: 8.67vmin;" src="../assets/img/silun.png" />
    </div>

    <img class="household animate__animated op0" v-intersect="'animate__fadeInRight'"
      src="../assets/img/household.png" />
    <div class="d-flex flex-column ai-center" :style="{
      transform: `rotate(90deg) scale(1,1)`,
      'transform- origin': 'center',
      'margin-top': '15.5vmin',
      'margin-right': '4.4vmin'
    }">
      <video controlsList="noplaybackrate noremoteplayback nodownload" ref="video2" @play="onPlay('video2')" controls
        @pause="onPause('video2Playing')" class="video1" poster="../assets/img/pre2.jpg">
        <source src="https://pic-cdn.bigdatajy.com/jiazhuanshang/chongqing-cjzp.mp4" type="video/mp4" />
        Sorry, your browser doesn't support embedded videos.
      </video>
      <img style="height: 4vmin;margin-top: 2vmin;" class="animate__animated op0 animate__delay"
        v-intersect="'animate__flipInX'" src="../assets/img/videoTitle2.png" />
    </div>
    <div :style="{
      transform: `rotate(90deg) scale(1,1)`,
      'transform-origin': 'center',
      'margin-top': '35vmin',
      'margin-right': '-9vmin',
      'z-index': 1001
    }">
      <div class="p-absolute bg-white iframe-content d-flex" style="top: 0;right: -18vmax;" v-if="showNews2">
        <iframe class="new-content" frameborder="no" :src="url" @load="loaded('iframe2')" ref="iframe2"></iframe>
        <div :class="{ 'close-bg': showIcon, op0: !showIcon }" @click="showNews2 = false">
          <van-icon name="cross" size="32" />
        </div>
      </div>
      <img class="mt-4vmin animate__animated op0 animate__delay" v-intersect="'animate__flipInX'"
        style="width: 25.1vmin;height: 5.87vmin;" src="../assets/img/focus.png" />
      <img class="mt-4vmin animate__animated op0 animate__delay" v-intersect="'animate__flipInX'" @click="
        newsClick(
          'http://newht.ijiangyin.com:5577/index.php/portal/news/index?id=558146&overflowx=auto&closeshare=1',
          'showNews2'
        )
        " style="width: 55.73vmin;height: 8.53vmin;" src="../assets/img/zhengzhi.png" />
      <!-- <img class="mt-4vmin animate__animated op0 animate__delay" v-intersect="'animate__flipInX'"
        @click="newsClick('http://newht.ijiangyin.com:5577/index.php/portal/news/index?id=557401&overflowx=auto&closeshare=1', 'showNews2')"
        style="width: 55.73vmin;height: 8.53vmin;" src="../assets/img/jinyu.png" /> -->
      <!-- <img class="mt-4vmin animate__animated op0 animate__delay" v-intersect="'animate__flipInX'"
        @click="newsClick('http://newht.ijiangyin.com:5577/index.php/portal/news/index?id=557174&overflowx=auto&closeshare=1', 'showNews2')"
        style="width: 55.6vmin;height: 8.53vmin;" src="../assets/img/jiangxin.png" /> -->
      <!-- <img class="mt-4vmin animate__animated op0 animate__delay" v-intersect="'animate__flipInX'"
        @click="newsClick('http://newht.ijiangyin.com:5577/index.php/portal/news/index?id=557173&overflowx=auto&closeshare=1', 'showNews2')"
        style="width: 56.13min;height: 8.53vmin;" src="../assets/img/jiuyuan.png" /> -->
    </div>

    <!-- <img class="micro animate__animated op0" v-intersect="'animate__fadeInRight'" src="../assets/img/micro.png" />
    <div class="d-flex flex-column ai-center"
      :style="{ transform: `rotate(90deg) scale(1,1)`, 'transform- origin': 'center', 'margin-top': '16.5vmin', 'margin-right': '4.5vmin' }">
      <video controlsList="noplaybackrate noremoteplayback nodownload" ref="video3" @play="onPlay('video3')" controls
        class="video1" poster="../assets/img/pre3.jpg">
        <source src="http://zjypic.oss-cn-shanghai.aliyuncs.com/anshang_wdj.mp4" type="video/mp4" />
        Sorry, your browser doesn't support embedded videos.
      </video>
      <img style="height: 5vmin;margin-top: 2vmin;" class="animate__animated op0 animate__delay"
        v-intersect="'animate__flipInX'" src="../assets/img/videoTitle3.png" />
    </div>
    <div
      :style="{ transform: `rotate(90deg) scale(1,1)`, 'transform-origin': 'center', 'margin-top': '25vmin', 'margin-right': '0', 'z-index': 1001 }">
      <div class="p-absolute bg-white iframe-content d-flex" style="top: 0;right: -18vmax;" v-if="showNews3">
        <iframe class="new-content" frameborder="no" :src="url" @load="loaded('iframe1')" ref="iframe1"></iframe>
        <div :class="{ 'close-bg': showIcon, 'op0': !showIcon }" @click="showNews3 = false"><van-icon name="cross"
            size="32" /></div>
      </div>
      <img class="mt-4vmin animate__animated op0 animate__delay" v-intersect="'animate__flipInX'"
        style="width: 25.1vmin;height: 5.87vmin;" src="../assets/img/focus.png" />
      <img class="mt-4vmin animate__animated op0 animate__delay" v-intersect="'animate__flipInX'"
        @click="newsClick('http://www.js.xinhuanet.com/20231211/a5ffccc9afcc4511bec63ba55d9e8676/c.html', 'showNews3')"
        style="width: 49.87vmin;height: 8.67vmin;" src="../assets/img/xuanyan.png" />
      <img class="mt-4vmin animate__animated op0 animate__delay" v-intersect="'animate__flipInX'"
        @click="newsClick('http://js.news.cn/20231123/48573c1f61b14f34a1bff85e4aad441d/c.html', 'showNews3')"
        style="width: 52.13vmin;height: 8.67vmin;" src="../assets/img/ge.png" />
    </div> -->
    <img class="speak animate__animated op0" v-intersect="'animate__fadeInRight'" src="../assets/img/speak.png" />
    <img class="dataBg animate__animated op0" v-intersect="'animate__zoomIn'" v-lazy="dataBgImg" />
    <img class="coordinate animate__animated op0" v-intersect="'animate__fadeInRight'"
      src="../assets/img/coordinate.png" />
    <van-swipe class="my-swipe animate__animated op0" v-intersect="'animate__zoomIn'" :autoplay="2500"
      :touchable="false" vertical indicator-color="#26CCE4">
      <van-swipe-item v-for="(item, i) in vlist" :key="i" @click="previewClick(i)"><img class="swiperItem"
          v-lazy="item" /></van-swipe-item>
    </van-swipe>

    <img class="book animate__animated op0" v-intersect="'animate__fadeInLeft'" src="../assets/img/book.png" />
    <img class="book-title animate__animated op0" v-intersect="'animate__fadeInRight'"
      src="../assets/img/bookTitle.png" />
    <img class="reporter animate__animated op0" v-intersect="'animate__zoomIn'" src="../assets/img/reporter.png" />
    <img class="logo animate__animated op0" v-intersect="'animate__zoomIn'" src="../assets/img/logo.png" />
    <!-- <van-popup overlay-class="overlay-class" v-model="show"
      :style="{ 'margin-top': this.verticalVisible ? `calc(-665vmin + ${showScroll}px + 40vmax + 10vmax)` : `calc(${showScroll}px + 50% + 10vmax)`, 'height': '80vmax', 'width': '80vmin' }"
      :get-container="getContainer">
      <iframe :style="{ transform: `rotate(90deg) scale(1,1)`, 'transform-origin': '0 0', 'margin-left': '80vmin' }"
        class="new-content" frameborder="no" :src="url" @load="loaded('iframe1')" ref="iframe1"></iframe>
    </van-popup> -->
  </div>
</template>

<script>
import { ImagePreview } from "vant";
import dataBgImg from "../assets/img/dataBg.png";
import v1Img from "../assets/img/v1.jpg";
import v2Img from "../assets/img/v2.jpg";
import v3Img from "../assets/img/v3.jpg";
import v4Img from "../assets/img/v4.jpg";
import v5Img from "../assets/img/v5.jpg";
import h1Img from "../assets/img/h1.jpg";
import h2Img from "../assets/img/h2.jpg";
import h3Img from "../assets/img/h3.jpg";
import h4Img from "../assets/img/h4.jpg";
import h5Img from "../assets/img/h5.jpg";

export default {
  name: "start",
  props: {
    verticalVisible: {
      type: Boolean,
      default: false
    },
    playing: {
      type: Boolean,
      default: false
    },
    scale: {
      type: Number,
      default: 1
    }
  },
  components: {},
  data() {
    return {
      show: false,
      url: "",
      scroll: 0,
      dataBgImg,
      showNews1: false,
      showNews2: false,
      scrollPosition: [0, 0],
      showNews3: false,
      vlist: [v1Img, v2Img, v3Img, v4Img, v5Img],
      hlist: [h1Img, h2Img, h3Img, h4Img, h5Img],
      allVideo: ["video1", "video2"],
      showIcon: false,
      video1Playing: false,
      video2Playing: false,
      showScroll: 0
    };
  },
  computed: {
    showNewsAll() {
      return this.showNews1 || this.showNews2 || this.showNews3;
    },
    videoPause() {
      return !this.video1Playing && !this.video2Playing;
    }
  },
  watch: {
    showNewsAll: {
      handler(val) {
        if (val) {
          this.$emit("endAudio");
        } else {
          this.$emit("playAudio");
        }
      }
    }
  },
  methods: {
    loaded(key) {
      this.showIcon = true;
    },
    handleIframeScroll(event) {
      this.$emit("endAudio");
    },
    getContainer() {
      return document.querySelector(".my-container");
    },
    onPause(key) {
      this[key] = false;
    },
    onPlay(key) {
      this.$emit("endAudio");
      this[`${key}Playing`] = true;
      for (let item of this.allVideo) {
        if (item !== key) {
          if (this.$refs[item].pause) {
            this.$refs[item].pause();
            this[`${item}Playing`] = false;
          }
        }
      }
      const video = this.$refs[key];
      // const scrollX = window.screenX || window.pageXOffset;
      // const scrollY = window.screenY || window.pageYOffset;
      // if (scrollX > 0 || scrollY > 0) {
      //   const scrollX = window.screenX || window.pageXOffset;
      //   const scrollY = window.screenY || window.pageYOffset;
      //   this.scrollPosition = [scrollX, scrollY]
      //   this.$emit('fullClick', [scrollX, scrollY])
      // }
      this.enterFullscreen(video);
    },
    enterFullscreen(element) {
      const scrollX = window.screenX || window.pageXOffset;
      const scrollY = window.screenY || window.pageYOffset;
      if (scrollX > 0 || scrollY > 0) {
        this.scrollPosition = [scrollX, scrollY];
        this.$emit("fullClick", [scrollX, scrollY]);
      }
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        // Chrome, Safari
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        // IE11
        element.msRequestFullscreen();
      }
    },
    hideAll() {
      this.showNews1 = false;
      this.showNews2 = false;
      this.showNews3 = false;
      this.showIcon = false;
    },
    newsClick(url, key, event) {
      // const scrollX = window.scrollX;
      // const scrollY = window.scrollY;
      // console.log(`滚动位置: scrollX=${scrollX}, scrollY=${scrollY}`);
      // this.show = true
      // this.showScroll = Math.max(scrollX, scrollY)
      this.url = url;
      this.hideAll();
      this[key] = true;
    },
    previewClick(i) {
      const list = this.verticalVisible ? this.vlist : this.hlist;
      ImagePreview({
        images: list,
        startPosition: i,
        showIndex: false
      });
    },
    handleFullscreenChange() {
      if (document.fullscreenElement || document.webkitIsFullScreen) {
        // 进入全屏时记录滚动位置
        const scrollX = window.screenX || window.pageXOffset;
        const scrollY = window.screenY || window.pageYOffset;
        if (scrollX > 0 || scrollY > 0) {
          this.scrollPosition = [scrollX, scrollY];
          this.$emit("fullClick", [scrollX, scrollY]);
        }
      } else {
        for (let item of this.allVideo) {
          if (this.$refs[item].pause) {
            this.$refs[item].pause();
          }
        }
        // 退出全屏时恢复滚动位置
        setTimeout(() => {
          window.scrollTo(this.scrollPosition[0], this.scrollPosition[1]);
        }, 200);
        setTimeout(() => {
          this.$emit("fullClick", [0, 0]);
        }, 300);
        this.$emit("playAudio");
      }
    },
    handleScroll(e) {
      if (this.videoPause && !this.playing && !this.showNewsAll) {
        this.$emit("playAudio");
      }
    }
  },
  created() { },
  mounted() {
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    document.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    this.$emit("endAudio");
  }
};
</script>

<style lang="scss">
.van-popup--center {
  max-height: unset;
  // top: unset;
  // left: unset;
}

.overlay-class {
  width: 100vmin;
  height: 1330.6666vmin;
}

.iframe-content {
  width: 70vmax;
  height: 85vmin;
  z-index: 1001;

  &::after {
    content: "";
    top: 0;
    right: 0;
    filter: blur(10px);
  }
}

.new-content {
  width: 70vmax;
  height: 85vmin;
  background-color: #fff;
}

.mt-4vmin {
  margin-top: 4vmin;
}

.to-right {
  height: 13.34vmin;
  width: 11vmin;
}

video::-webkit-media-controls-panel {
  background: none;
}

.van-swipe__indicators--vertical {
  left: 11vmin !important;
  top: unset;
  bottom: 0;
}

.my-swipe {
  margin-top: 6vmin;
  margin-right: 4.27vmin;
  width: 83.1vmin;
  height: 131.2vmin;
}

.van-swipe__indicator {
  width: 12px !important;
  height: 12px !important;
}

.swiperItem {
  width: 83.1vmin;
  height: 131.2vmin;
}

.op0 {
  opacity: 0;
}

.dataBg {
  width: 90.4vmin;
  // height: 158.67vmin;
  margin-top: 5.33vmin;
  margin-right: 4.27vmin;
}

.reporter {
  width: 95.73vmin;
  // width: 146.93vmin;
  // height: 158.67vmin;
  margin-top: 7vmin;
  margin-right: 4.27vmin;
}

.logo {
  width: 76.4vmin;
  // width: 146.93vmin;
  // height: 158.67vmin;
  margin-top: 67.857vmin;
  margin-right: 11vmin;
}

.video1 {
  width: 62.93vmin;
}

.video2 {
  // height: 49vmin;
  width: 100vmin;
  margin-right: -9vmin;
  margin-top: 30vmin;
}

.speak {
  width: 46.67vmin;
  height: 10.67vmin;
  margin-top: 52vmin;
  margin-right: 10.13vmin;
}

.coordinate {
  height: 10.67vmin;
  width: 29.6vmin;
  margin-top: 45vmin;
  margin-right: 12.53vmin;
}

.east {
  width: 67.6vmin;
  height: 10.67vmin;
  margin-top: 21vmin;
  margin-right: 11vmin;
}

.household {
  height: 10.67vmin;
  width: 48.93vmin;
  margin-right: 12vmin;
  margin-top: 51.5vmin;
}

.micro {
  height: 10.67vmin;
  width: 48.93vmin;
  margin-right: 12.8vmin;
  margin-top: 48.13vmin;
}

.book {
  height: 24.8vmin;
  width: 22.93vmin;
  margin-top: 31.8vmin;
  margin-right: 47.3vmin;
}

.book-title {
  height: 10.67vmin;
  width: 35.2vmin;
  margin-right: 7.8vmin;
  margin-top: -9.8vmin;
}

.location {
  height: 148vmin;
  width: 71.2vmin;
  margin-right: 8.5vmin;
  margin-top: 13.6vmin;
}

.start {
  background-image: url("../assets/img/bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100vmin;
  height: 1330.6666vmin;
  background-color: #7fe1ee;
  position: relative;
}

// .start-blur::before {
//   content: "";
//   position: absolute;
//   top: 0;
//   right: 0;
//   bottom: 0;
//   left: 0;
//   backdrop-filter: blur(50px);
//   background-color: rgb(1, 1, 1, 0.2);
//   border-radius: 8px;
//   z-index: 1;
// }

.close-bg {
  background-color: rgb(1, 1, 1, 0.2);
  height: min-content;
}

.bg-img {
  width: 100vmin;
  object-fit: contain;
}

.img-container {
  width: 100vmin;
  height: 100vmax;
  // opacity: 0.4;
  // animation: fadeIn 2s forwards;
  background-image: url("../assets/img/poster.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #7fe1ee;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/start.vue